
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const CareerCompetenciesPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#0244021A',
            100: '#0244021A',
            200: '#024402',
            300: '#024402',
            400: '#024402',
            500: '#024402',
            600: '#023B02',
            700: '#023B02',
            800: '#023B02',
            900: '#013201',
            950: '#013201'
        }
    },
    extend: {
        secondary: {
            50: '#FFFFFF',
            100: '#F9FDF7',
            200: '#F1FEEA',
            300: '#E9F8DC',
            400: '#D9F1CE',
            500: '#F8FEE',
            600: '#D1E8D5',
            700: '#A9C6A2',
            800: '#87A78F',
            900: '#668B7B',
            950: '#4F7269'
        }
    }
});